import apiHandler, { resultParser } from "../../../utils/api";

export async function queryTable(params) {
    return apiHandler.get('/api/user-mng/list', { params }).then(resultParser)
}

export async function createUser(data) {
    return apiHandler.post('/api/users/register', data).then(resultParser)
}

export async function editUser(data) {
    return apiHandler.post('/api/user-mng/edit-by-id', data).then(resultParser)
}
